import { gql } from "@apollo/client";

export const FIND_ALL_STRATEGIES_BY_LOCATION = gql`
  query FindAllStrategiesByLocation($uuid: ID!) {
    findAllStrategiesByLocation(uuid: $uuid) {
      grossRevenueExposure
      lengthOfDisruption
      mitigation
      netRevenueExposure
      strategyAge
      summary
      uuid
      lastUpdate
      bcpStatus
      isDefault
    }
  }
`;

export const CREATE_STRATEGY = gql`
  mutation Strategy($data: CreateStrategyInput!) {
    createStrategy(data: $data) {
      grossRevenueExposure
      lengthOfDisruption
      mitigation
      netRevenueExposure
      strategyAge
      summary
      uuid
    }
  }
`;

export const UPDATE_STRATEGY = gql`
  mutation Strategy($data: UpdateStrategyInput!) {
    updateStrategy(data: $data) {
      grossRevenueExposure
      lengthOfDisruption
      mitigation
      netRevenueExposure
      strategyAge
      summary
      uuid
    }
  }
`;

export const FETCH_STRATEGY_SUMMARY = gql`
  query FetchStrategySummary($uuid: ID!) {
    findAllStrategiesByLocation(uuid: $uuid) {
      externalMitigation
      finishedGoodsInventory
      grossRevenueExposure
      internalMitigation
      lengthOfDisruption
      mitigation
      netRevenueExposure
      percentageBusinessSupported
      revenueSupportedAnnually
      strategyAge
      summary
      uuid
      lastUpdate
      bcpStatus
    }
  }
`;

export const FINALIZE_STRATEGY = gql`
  mutation FinalizeStrategy($data: FinalizeInput!) {
    finalizeStrategy(data: $data) {
      lastUpdate
      uuid
    }
  }
`;

export const DELETE_STRATEGY = gql`
  mutation DeleteStrategy($uuid: ID!) {
    deleteStrategy(uuid: $uuid) {
      externalMitigation
      finishedGoodsInventory
      grossRevenueExposure
      internalMitigation
      lastUpdate
      lengthOfDisruption
      mitigation
      netRevenueExposure
      percentageBusinessSupported
      revenueSupportedAnnually
      strategyAge
      summary
      uuid
    }
  }
`;
